import { nextTick, reactive } from 'vue';
export const vueComponentRenderer = Object.freeze({
    makeReactive(data) {
        return reactive(data);
    },
    flush: nextTick,
});
//# sourceMappingURL=vue-component-renderer.js.map